import { ProductCategory } from '../models/product.models';

export function leafProductCategories(categories: ProductCategory[]): ProductCategory[] {
  const active = categories.filter((category) => category.isActive !== false);
  const parentIds = new Set(
    active.map((category) => category.parentCategoryId).filter((id): id is string => Boolean(id)),
  );
  return active.filter((category) => !parentIds.has(category.id));
}

export function productCategoryPath(category: ProductCategory, categories: ProductCategory[]): string {
  const names: string[] = [];
  const visited = new Set<string>();
  let current: ProductCategory | undefined = category;

  while (current && !visited.has(current.id)) {
    visited.add(current.id);
    names.unshift(current.name);
    current = categories.find((item) => item.id === current?.parentCategoryId);
  }

  return names.join(' › ');
}
